
import { useQuery } from "@tanstack/react-query";
import axios from "axios";


const fetchMentorRoles = async () => {
  const response = await axios.get(`${process.env.REACT_APP_API_URL}/superAdmin/role`);
  return response.data.data;
};

export function useMentorRoles() {
  return useQuery({
    queryKey: ['mentor-roles'],
    queryFn: fetchMentorRoles,
    staleTime: 15 * 60 * 1000, // 15 minutes
    gcTime: 30 * 60 * 1000, // 30 minutes
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
}